export default __webpack_public_path__ + "static/media/mr.33c53679.jpg";